import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.ReportEditPopup', {
    titleRequest: 'Edit request report',
    titleLineItem: 'Edit line item report',
    donePopupButton: 'Done',
    loadingText: 'Loading data...',
    reportTypeTabText: 'Request type',
    visibleColumnsTabText: 'Visible columns',
    filtersTabText: 'Filters',

    buttonSave: 'Save changes',

    tabReportType: 'Request type',
    tabVisibleColumns: 'Visible columns',
    tabFilters: 'Filters',
});
